var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeSquare = function SvgBadgeSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0C49A5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4H4v8h8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 4v8H4V4zm1-1H3v10h10z"
  }))));
};
export default SvgBadgeSquare;